import { httpCreate } from './http';

const http = httpCreate('/srv/copyExample');

export const copyExample = {
	// 获取所有案例
	// photolive 直播 0，云摄影：1
	getCopyExample(params) {
		return http.get('', { params });
	},
	// 隐藏案例
	closeExample(id) {
		return http.put(`/close/${id}`);
	},
	// 显示案例
	openExample(id) {
		return http.put(`/open/${id}`);
	},
	// 删除案例
	deleteExample(id, verifyCode) {
		return http.delete(`/delete/${id}?verifyCode=${verifyCode}`);
	},
};
